import { render, staticRenderFns } from "./create_space.vue?vue&type=template&id=27daf9e3&scoped=true"
import script from "./create_space.vue?vue&type=script&lang=js"
export * from "./create_space.vue?vue&type=script&lang=js"
import style0 from "./create_space.vue?vue&type=style&index=0&id=27daf9e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27daf9e3",
  null
  
)

export default component.exports